import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const navigationItems = [{
  path: '/about',
  label: 'About'
}, {
  path: '/benefits',
  label: 'Benefits'
}, {
  path: '/partners',
  label: 'Partners'
}, {
  path: '/presentations',
  label: 'Presentations'
}, {
  path: '/contact',
  label: 'Contact'
}];
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  return <header className="bg-black border-b border-gray-800 py-4 px-4 sm:px-6 lg:px-8 relative z-50" data-id="element-26">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-27">
        <Link to="/" className="flex items-center" onClick={closeMobileMenu} data-id="element-28">
          <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/2c6dce52-3a64-4bfa-a2a2-ec0b6bf9870c/tactical_investor_mastermind.png" alt="Tactical Investor Mastermind Logo" className="h-10 w-auto mr-3" data-id="element-29" />
          <span className="font-bold text-lg hidden sm:block" data-id="element-30">
            Tactical Investor Mastermind
          </span>
        </Link>
        <nav className="hidden md:flex space-x-8 items-center" data-id="element-31">
          {navigationItems.map(item => <Link key={item.path} to={item.path} className="text-gray-300 hover:text-white" data-id="element-32">
              {item.label}
            </Link>)}
          <a href="https://calendly.com/gregnamrow/1v1-meeting-tacticalinvestormastermind" target="_blank" rel="noopener noreferrer" className="bg-[#4a7c59] hover:bg-[#3d6649] text-white py-2 px-4 rounded" data-id="element-33">
            Join Now
          </a>
        </nav>
        <button onClick={toggleMobileMenu} className="md:hidden text-gray-300 hover:text-white" aria-label="Toggle mobile menu" data-id="element-34">
          {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-35" /> : <MenuIcon className="h-6 w-6" data-id="element-36" />}
        </button>
        {isMobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-black border-b border-gray-800 md:hidden z-50" data-id="element-37">
            <nav className="max-w-7xl mx-auto py-4 px-4 space-y-4" data-id="element-38">
              {navigationItems.map(item => <Link key={item.path} to={item.path} className={`block text-lg ${location.pathname === item.path ? 'text-white' : 'text-gray-300'} hover:text-white`} onClick={closeMobileMenu} data-id="element-39">
                  {item.label}
                </Link>)}
              <a href="https://calendly.com/gregnamrow/1v1-meeting-tacticalinvestormastermind" target="_blank" rel="noopener noreferrer" className="block bg-[#4a7c59] hover:bg-[#3d6649] text-white py-2 px-4 rounded text-lg text-center" onClick={closeMobileMenu} data-id="element-40">
                Join Now
              </a>
            </nav>
          </div>}
      </div>
    </header>;
}